import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IDropdown, IPackage } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVTextArea } from "../../shared/JVTextarea";
import { JVMultiselect } from "../../shared/JVMultiselect";
import { FileUpload } from "primereact/fileupload";

const schema = yup.object({
    name: yup.string().required("Pickup Location Name is required"),
    desc: yup.string().nullable(),
    cityId: yup.number().required("Destination is required").min(1, "Destination is required"),
    basePrice: yup.number().typeError("Base Price must be a number").required("Base Price is Required").positive("Can't be negative"),
    duration: yup.number().nullable().typeError("Duration must be a number").positive("Duration must be a positive number").required("Duration is required"),
    maxPerson: yup.number().typeError("Max Person must be a number").required("Max Person is Required").positive("Can't be negative"),

});

interface Iprops {
    singleData: IPackage,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [submitting, setSubmitting] = useState(false);
    const [sopts, setSopts] = useState<IDropdown[]>();
    const [selectedSopts, setSelectedSopts] = useState<{ citySpotId: number, packageId: number }[]>();
    const [imageType, setImageType] = useState<string>("");
    const [image, setImage] = useState(false);
    const [resumeFile, setResumeFile] = useState<File | null | any>(null);
    const { control, handleSubmit, formState: { errors }, setValue, reset, watch } = useForm<IPackage>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    const daysOptions = Array.from({ length: 30 }, (_, i) => ({ label: `${i + 1}`, value: i + 1 }));
    const nightsOptions = Array.from({ length: 30 }, (_, i) => ({ label: `${i + 1}`, value: i + 1 }));
    const days = watch("days");
    const nights = watch("nights");

    useEffect(() => {
        if (days && nights) {
            const dayLabel = days === 1 ? "Day" : "Days";
            const nightLabel = nights === 1 ? "Night" : "Nights";

            const formattedName = `${days} ${dayLabel} / ${nights} ${nightLabel}`;
            setValue("name", formattedName);
            setValue('duration', (days + nights) * 12);
        } else {
            setValue("name", "");
        }
    }, [days, nights, setValue]);


    useEffect(() => {
        reset(props.singleData);
        if (props.singleData.id) {
            setSelectedSopts(
                props.singleData.pakageSpots?.map(rb => ({
                    packageId: rb.packageId ?? 0,
                    citySpotId: rb.citySpotId
                }))
            );
        }
    }, [props.singleData]);

    useEffect(() => {
        if (props.singleData?.id && props.singleData?.name) {
            const name = props.singleData.name.toUpperCase();
            const numbers = name.match(/\d+/g);
            if (numbers && numbers.length >= 2) {
                let d = 0, n = 0;
                if (name.includes("DAY") && name.includes("NIGHT")) {
                    const dayMatch = name.match(/(\d+)\s*DAY/);
                    const nightMatch = name.match(/(\d+)\s*NIGHT/);
                    d = dayMatch ? parseInt(dayMatch[1]) : 0;
                    n = nightMatch ? parseInt(nightMatch[1]) : 0;
                }
                else {
                    d = parseInt(numbers[0]);
                    n = parseInt(numbers[1]);
                }
                setValue("days", d);
                setValue("nights", n);
            }
        }
    }, [props.singleData, setValue]);



    // const saveToDB = async (body: IPackage) => {
    //     setSubmitting(true);
    //     const method = props.singleData.id ? "PUT" : "POST";
    //     const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";

    //     const response = await Fetch(`package${props.singleData.id ? '/' + props.singleData.id : ''}`, method, body, null, props.toast);
    //     if (response) {
    //         onHide();
    //         props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
    //         props.reloadData();
    //     }
    //     setSubmitting(false);
    // }

    const saveToDB = async (data: IPackage) => {
        setSubmitting(true);

        const url = props.singleData.id
            ? `${baseUrl}package/${props.singleData.id}`
            : `${baseUrl}package/add`;

        const method = props.singleData.id ? "PUT" : "POST";

        const formData = new FormData();

        if (resumeFile instanceof File) {
            formData.append("image", resumeFile);
        }

        formData.append("packageJson", JSON.stringify(data));

        const response = await fetch(url, {
            method: method,
            headers: {
                Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`
            },
            body: formData
        });

        if (!response.ok) {
            const error = await response.json();
            props.toast.current.show({
                severity: "error",
                detail: error.error,
                life: 3000
            });
            setSubmitting(false);
            return;
        }

        props.toast.current.show({
            severity: "success",
            detail: props.singleData.id ? "Updated Successfully" : "Added Successfully",
            life: 3000
        });

        props.reloadData();
        onHide();
        setSubmitting(false);
    };




    const onHide = () => {
        props.hideDialog();
        reset({});
        setSelectedSopts(undefined);
        setImage(false);
    }

    function onSubmit(data: any) {
        if (selectedSopts === undefined || selectedSopts.length < 1) {
            props.toast.current.show({ severity: 'error', detail: 'Select Spots', life: 3000 });
            return;
        }
        else if (!image && (props.singleData.id === null || props.singleData.id === undefined)) {
            props.toast.current?.show({ severity: 'error', detail: "Please Upload Image First", life: 3000 });
        } else {
            data.pakageSpots = selectedSopts?.map(s => ({ citySpotId: s.citySpotId, packageId: s.packageId }));
            saveToDB(data);
        }
    }

    const onBedsChange = (newBeds: any[]) => {
        setSelectedSopts(prev => {
            return newBeds.map((b: any) => {
                const existing = prev?.find(p => p.citySpotId === b.id);
                const quantity = existing?.citySpotId && existing.packageId > 0 ? existing.packageId : 1;
                return { citySpotId: b.id, packageId: quantity };
            });
        });
    };

    const loadBedTypes = async () => {
        console.log(props.singleData.cityId)
        const response = await Fetch(`Destination/dropdown`, "GET", null, `cityid=${props.singleData.cityId}`, null);
        if (response) {
            setSopts(await response.json());
        }
    }

    const onUpload = (event: any) => {
        const file = event.files[0];
        setImageType(event.files[0].type.split("/")[1]);

        if (event.files[0].type === "image/png" || event.files[0].type === "image/jpeg" || event.files[0].type === "image/jpg") {
            if (event.files[0].size > 1024 * 1024 * 2) {
                props.toast.current.show({ severity: 'error', content: "Image File should be less than 2 MB." });
                event.options.clear();
            } else {
                setResumeFile(file);
                setImage(true);
                event.options.clear();
                props.toast.current.show({ severity: 'success', summary: 'Success', detail: "Image Uploaded", life: 3000 });
            }
        } else {
            props.toast.current.show({ severity: 'error', content: "Please Choose A Image(PNG/JPEG) File." });
            event.options.clear();
        }
    };

    useEffect(() => {
        if (props.open) {
            loadBedTypes();
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '600px' }} header="Add/Edit Package" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdown column={2} label="Day(s)" name="days" control={control} options={daysOptions} optionLabel="label" optionValue="value" required placeholder="Select Day(s)" error={errors.days?.message} />
                <JVDropdown column={2} label="Night(s)" name="nights" control={control} options={nightsOptions} optionLabel="label" optionValue="value" required placeholder="Select Night(s)" error={errors.nights?.message} />
                <JVInput column={1} required label="Package" control={control} name="name" error={errors.name?.message} disabled />
                {/* <JVInput column={1} required label="Package" control={control} name="name" error={errors.name?.message} /> */}
                {/* <JVInput column={1} required label="Duration(H)" control={control} name="duration" error={errors.duration?.message} /> */}
                <JVInput type="number" column={1} required label="Price/Person" control={control} name="basePrice" error={errors.basePrice?.message} />
                <JVInput type='number' column={1} required label="No Of Person" control={control} name="maxPerson" error={errors.maxPerson?.message} />

                <JVMultiselect required column={1} label="Spot" options={sopts} optionLabel="name" placeholder="Select Spots" value={sopts?.filter(bt => selectedSopts?.map(e => e.citySpotId).includes(bt.id))} onChange={e => onBedsChange(e)} />
                <JVTextArea column={1} label="Description" control={control} name="desc" error={errors.desc?.message} />
                {props.singleData.id && <JVCheckbox column={2} label="Status" control={control} name="isActive" />}
                <div className="card flex justify-content-center">
                    <FileUpload chooseLabel="Choose Image" mode="basic" name="image" accept="image/*" customUpload uploadHandler={onUpload} auto />
                </div>
                <JVCheckbox column={1} label="IsFeature" control={control} name="isFeature" />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-2">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}